var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.users && _vm.users.length)?_c('v-data-table',{attrs:{"items":_vm.users,"headers":_vm.headers},scopedSlots:_vm._u([{key:"item.action",fn:function({ item }){return [_c('v-btn',{attrs:{"small":"","color":"secondary","depressed":""},on:{"click":function($event){return _vm.assign(item)}}},[_vm._v("assign")])]}}],null,false,4220345494)}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }